import './UpperControls.css';
import { h } from 'preact';
import Skip from './Skip';
import Countdown from './Countdown';
import BaseComponent from '../BaseComponent';

export default class UpperControls extends BaseComponent {
  constructor(state) {
    super();
  }

  render(props) {
    let classes = 'upper-controls';

    if(props.media.current_time >= 0 && (props.options.countdown || props.options.skip)) {
      if(props.options.skip && !props.options.countdown) {
        if(props.media.canSkip) {
          classes += ' enabled';
        }
      } else {
        classes += ' enabled';
      }
    }

    return (
      <div class={ classes }>
        <Countdown media={ this.props.media } options={ this.props.options } />
        <Skip media={ this.props.media } options={ this.props.options } onSkip={ props.onSkip } />
      </div>
    )
  }

  static supported({ configuration }) {
    return configuration.UI.countdown || configuration.UI.skip;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/UpperControls/UpperControls.js